"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {findIn, addClass, removeClass, hasClass, setAttribute, setText, on} from '@elements/dom-utils';
import debounce from 'debounce';

const selectors = {
    base: '.js-icon-showcase',
    grid: '.js-icon-showcase__grid',
    tile: '.js-icon-showcase__tile',
    toggle: '.js-icon-showcase__toggle',
    toggleLabel: '.js-icon-showcase__toggle-label'
};

const collapsibleClass = 'is-collapsible';
const expandedClass = 'is-expanded';
const rowHeightProperty = '--icon-showcase-row-height';
const resizeDelay = 200;

export function init () {
    onFind(selectors.base, function (baseElement) {
        let grid = findIn(selectors.grid, baseElement);
        let toggle = findIn(selectors.toggle, baseElement);

        if (!grid || !toggle) {
            return;
        }

        let labelElement = findIn(selectors.toggleLabel, toggle);
        let labelCollapsed = toggle.getAttribute('data-label-collapsed');
        let labelExpanded = toggle.getAttribute('data-label-expanded');

        // clipping and toggle only become active once the JS runs — without it the full grid stays visible
        addClass(collapsibleClass, baseElement);
        collapse();

        on('click', function () {
            if (hasClass(expandedClass, baseElement)) {
                collapse();
            } else {
                expand();
            }
        }, toggle);

        // the column count — and with it the height of a single row — depends on the viewport width
        on('resize', debounce(function () {
            if (!hasClass(expandedClass, baseElement)) {
                updateRowHeight();
            }
        }, resizeDelay), window);

        function collapse () {
            updateRowHeight();
            removeClass(expandedClass, baseElement);
            setAttribute('aria-expanded', 'false', toggle);

            if (labelElement && labelCollapsed) {
                setText(labelCollapsed, labelElement);
            }
        }

        function expand () {
            addClass(expandedClass, baseElement);
            setAttribute('aria-expanded', 'true', toggle);

            if (labelElement && labelExpanded) {
                setText(labelExpanded, labelElement);
            }
        }

        // the collapsed height is the height of one tile, which the SCSS fallback can only guess
        function updateRowHeight () {
            let tile = findIn(selectors.tile, grid);

            if (tile && tile.offsetHeight) {
                baseElement.style.setProperty(rowHeightProperty, `${tile.offsetHeight}px`);
            }
        }
    });
}
